export default __webpack_public_path__ + "static/media/VA.ce0e7482.png";